import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from './AffichageGrapheAutomatiqueXT.module.scss';
import * as actions from '../../../services/actions';
import GrapheXT from './GrapheXT/GrapheXT';
import Bouton from '../../UI/Bouton/Bouton';
import Popup from '../../UI/Popup/Popup';
import ChangementIntervalTempsGrapheAutomatique from './ChangementEchantillonGrapheAutomatiqueXT/ChangementIntervalTempsGrapheAutomatique';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import { checkPhrase } from '../../../ressources/functionJS/checkPhrase';

const AffichageGrapheAutomatiqueXT = ({
  sensor_id,
  position_in_sensor,
  debut_date,
  fin_date,
  prefix,
  derniereValeur,
  engineering_unit,
  dimensionWidth,
  dimensionHeight,
}) => {
  const dispatch = useDispatch();

  // State
  const [afficherModifierIntervalle, setAfficherModifierIntervalle] =
    useState(false);

  // Redux selector
  const donneesGraphe = useSelector(
    (state) =>
      state.graphe.liste_donnees_graphes[
        sensor_id + '+' + position_in_sensor
      ] || {}
  );

  // Functions
  const reqRecupererDonneesGrapheAutomatiqueXT = React.useCallback(
    (sensor_id, position_in_sensor) => {
      dispatch(
        actions.reqRecupererDonneesGrapheAutomatiqueXT(
          sensor_id,
          position_in_sensor,
          null,
          null,
          [],
          [null, null]
        )
      );
    },
    [dispatch]
  );

  const reqRecupererDonneesGrapheAutomatiqueXTIntervalle = React.useCallback(
    (sensor_id, position_in_sensor, debut_date, fin_date) => {
      dispatch(
        actions.reqRecupererDonneesGrapheAutomatiqueXT(
          sensor_id,
          position_in_sensor,
          null,
          null,
          [],
          [debut_date, fin_date]
        )
      );
    },
    [dispatch]
  );

  const envoieReq = () => {
    if (sensor_id !== undefined && position_in_sensor !== undefined) {
      if (debut_date !== undefined && fin_date !== undefined) {
        reqRecupererDonneesGrapheAutomatiqueXTIntervalle(
          sensor_id,
          position_in_sensor,
          debut_date,
          fin_date
        );
      } else {
        reqRecupererDonneesGrapheAutomatiqueXT(sensor_id, position_in_sensor);
      }
    }
  };

  const switchAfficherModifierIntervalle = () => {
    setAfficherModifierIntervalle((prev) => !prev);
  };

  // Effect for initial data fetch
  useEffect(() => {
    if (sensor_id !== undefined && position_in_sensor !== undefined) {
      if (debut_date !== undefined && fin_date !== undefined) {
        reqRecupererDonneesGrapheAutomatiqueXTIntervalle(
          sensor_id,
          position_in_sensor,
          debut_date,
          fin_date
        );
      } else {
        reqRecupererDonneesGrapheAutomatiqueXT(sensor_id, position_in_sensor);
      }
    }
  }, [
    sensor_id,
    position_in_sensor,
    debut_date,
    fin_date,
    reqRecupererDonneesGrapheAutomatiqueXT,
    reqRecupererDonneesGrapheAutomatiqueXTIntervalle,
  ]);

  // Render helper function
  const renderGraph = () => {
    if (!donneesGraphe?.config) {
      return (
        <Bouton ajoutClass={styles.style} cliquer={envoieReq}>
          {checkMot('refresh')}
        </Bouton>
      );
    }

    const config = {
      ...donneesGraphe.config,
      title:
        donneesGraphe.config.title?.indexOf('évolution du capteur ') > 0
          ? checkPhrase(
              'traduction_titre_graphe_automatique',
              donneesGraphe.config.title.substring(
                'évolution du capteur '.length,
                donneesGraphe.config.title.length -
                  ' en fonction du temps'.length
              )
            )
          : checkPhrase(
              'traduction_titre_graphe_automatique',
              donneesGraphe.config.title
            ),
    };

    return (
      <GrapheXT
        donneesGraphe={donneesGraphe}
        switchAfficherModifierIntervalle={switchAfficherModifierIntervalle}
        dimensionWidth={dimensionWidth}
        dimensionHeight={dimensionHeight}
        configuration={config}
        donnees={donneesGraphe.data}
        seuils={donneesGraphe.alarms_levels}
      />
    );
  };

  if (!donneesGraphe?.config) {
    return (
      <Bouton ajoutClass={styles.style} cliquer={envoieReq}>
        {checkMot('refresh')}
      </Bouton>
    );
  }

  return (
    <Popup
      eventAuClique={envoieReq}
      afficherLien={true}
      texte_ouverture={`${prefix} = ${derniereValeur} ${engineering_unit}`}
    >
      <AttenteRequete
        request_type={
          requestType.recuperation_des_donnees_d_un_graphe_automatique_xt
        }
        str={checkMot('en_cour_de_reception_des_donnees_du_graphe_automatique')}
      >
        {renderGraph()}
      </AttenteRequete>
      <ChangementIntervalTempsGrapheAutomatique
        sensor_id={sensor_id}
        position_in_sensor={position_in_sensor}
        afficherPopup={afficherModifierIntervalle}
        fermerPopupModifierIntervalle={switchAfficherModifierIntervalle}
      />
    </Popup>
  );
};

export default AffichageGrapheAutomatiqueXT;
